import * as React from "react";

function Pick3(props) {
  return (
    <svg
      width={300}
      height={300}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={151.865}
        cy={151.748}
        r={118.727}
        fill="#1C1A1B"
        stroke="#ABA9A7"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={32}
        y={30}
        width={239}
        height={240}
      >
        <circle
          cx={151.598}
          cy={150.072}
          r={119.227}
          transform="rotate(-82.888 151.598 150.072)"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M209.198 239.018l9.279-28.802 2.985-36.509 21.604-19.962 11.735-25.88-8.276-51.976 56.456 101.486-93.783 61.643z"
          fill="#7D0E03"
        />
        <path
          d="M229.541 209.089l-9.116-24.364.495-10.443 21.715-19.793 10.949 4.762-23.317 20.155-.726 29.683z"
          fill="#951D09"
        />
        <path
          d="M230.074 225.296l-4.175 2.744 3.912-19.589.667-28.724 3.345 1.941-1.195 27.921-2.554 15.707z"
          fill="#CC3B1E"
        />
        <path
          d="M232.644 223.607l17.718-27.974 25.224-26.698 1.64-30.744 25.755 39.184-70.337 46.232z"
          fill="#30180E"
        />
        <path
          d="M250.095 195.579l-16.378-14.071 41.438-11.829-25.06 25.9zM274.733 169.035l-31.405-14.542 17.513-12.891 13.892 27.433zM277.116 138.723l-15.497-10.281-8.569-26.333 24.066 36.614z"
          fill="#E34C2D"
        />
        <path
          d="M250.785 196.277l24.908-27.181 10.853 11.264-35.761 15.917zM261.058 141.233l16.005-2.241-1.792 29.463-14.213-27.222z"
          fill="#951D09"
        />
        <path
          d="M209.198 239.018l9.279-28.801 2.985-36.51 21.604-19.961 11.735-25.881-5.957-47.776 54.137 97.286-93.783 61.643z"
          fill="#7D0E03"
        />
        <path
          d="M229.541 209.09l-9.116-24.364.495-10.443 21.715-19.793 10.949 4.762-23.317 20.155-.726 29.683z"
          fill="#951D09"
        />
        <path
          d="M230.074 225.296l-4.175 2.745 3.912-19.589.667-28.725 3.345 1.941-1.194 27.921-2.555 15.707z"
          fill="#CC3B1E"
        />
        <path
          d="M232.644 223.607l17.718-27.973 25.224-26.699 1.64-30.743 25.755 39.183-70.337 46.232z"
          fill="#30180E"
        />
        <path
          d="M250.095 195.579l-16.378-14.071 41.438-11.829-25.06 25.9zM274.733 169.036l-31.405-14.542 17.513-12.891 13.892 27.433zM277.116 138.723l-15.497-10.281-6.955-46.56 22.452 56.841z"
          fill="#E34C2D"
        />
        <path
          d="M250.785 196.277l24.908-27.18 10.853 11.264-35.761 15.916zM261.058 141.233l16.005-2.241-1.791 29.464-14.214-27.223z"
          fill="#951D09"
        />
        <path
          d="M187.846 241.33l14.401-8.899 14.518-14.466 16.443-.662 14.388-6.765 9.837-19.792-7.282 58.358-62.305-7.774z"
          fill="#7D0E03"
        />
        <path
          d="M207.368 235.965l4.958-13.684 4-4.268 16.429-.55 2.935 6-17.243.124-11.079 12.378z"
          fill="#951D09"
        />
        <path
          d="M201.716 243.06l-2.774-.346 8.773-6.923 10.706-11.991.72 2.04-10.639 11.457-6.786 5.763z"
          fill="#CC3B1E"
        />
        <path
          d="M203.423 243.274l17.695-5.485 20.429-2.218 11.852-12.498-3.247 26.031-46.729-5.83z"
          fill="#30180E"
        />
        <path
          d="M221.024 237.669l-1.87-11.935 21.94 9.996-20.07 1.939zM241.147 235.303l-8.099-17.588 12.136.864-4.037 16.724zM253.159 223.259l-2.869-10.001 5.904-14.324-3.035 24.325z"
          fill="#E34C2D"
        />
        <path
          d="M221.064 238.215l20.469-2.538.536 8.734-21.005-6.196zM245.41 218.502l7.629 4.852-11.453 11.898 3.824-16.75z"
          fill="#951D09"
        />
        <path
          d="M187.846 241.33l14.401-8.899 14.518-14.466 16.443-.662 14.388-6.765 9.837-19.792-7.281 58.358-62.306-7.774z"
          fill="#7D0E03"
        />
        <path
          d="M207.368 235.965l4.958-13.684 4-4.268 16.429-.55 2.935 6-17.243.124-11.079 12.378z"
          fill="#951D09"
        />
        <path
          d="M201.716 243.06l-2.774-.346 8.773-6.923 10.706-11.991.72 2.04-10.639 11.457-6.786 5.763z"
          fill="#CC3B1E"
        />
        <path
          d="M203.423 243.274l17.695-5.485 20.429-2.218 11.853-12.498-3.248 26.031-46.729-5.83z"
          fill="#30180E"
        />
        <path
          d="M221.024 237.669l-1.869-11.935 21.939 9.996-20.07 1.939zM241.147 235.303l-8.098-17.588 12.135.864-4.037 16.724zM253.159 223.259l-2.869-10.001 5.904-14.324-3.035 24.325z"
          fill="#E34C2D"
        />
        <path
          d="M221.064 238.215l20.47-2.538.535 8.734-21.005-6.196zM245.41 218.502l7.629 4.852-11.452 11.898 3.823-16.75z"
          fill="#951D09"
        />
        <path
          d="M99.034 263.665l25.74-15.907 25.949-25.856 29.391-1.184 25.716-12.09 17.583-35.377-13.015 104.309-111.364-13.895z"
          fill="#7D0E03"
        />
        <path
          d="M133.928 254.075l8.861-24.458 7.149-7.629 29.366-.984 5.246 10.725-30.82.221-19.802 22.125z"
          fill="#951D09"
        />
        <path
          d="M123.824 266.758l-4.958-.619 15.681-12.374 19.136-21.433 1.287 3.647-19.016 20.479-12.13 10.3z"
          fill="#CC3B1E"
        />
        <path
          d="M126.875 267.138l31.627-9.804 36.516-3.965 21.185-22.339-5.805 46.529-83.523-10.421z"
          fill="#30180E"
        />
        <path
          d="M158.336 257.12l-3.342-21.332 39.214 17.868-35.872 3.464zM194.303 252.893l-14.475-31.437 21.691 1.545-7.216 29.892zM215.775 231.364l-5.129-17.876 10.554-25.602-5.425 43.478z"
          fill="#E34C2D"
        />
        <path
          d="M158.408 258.099l36.587-4.537.957 15.612-37.544-11.075zM201.924 222.861l13.636 8.673-20.47 21.266 6.834-29.939z"
          fill="#951D09"
        />
        <path
          d="M99.033 263.665l25.741-15.907 25.949-25.856 29.39-1.184 25.717-12.09 17.582-35.377-13.014 104.309-111.365-13.895z"
          fill="#7D0E03"
        />
        <path
          d="M133.927 254.075l8.861-24.458 7.149-7.629 29.366-.984 5.246 10.725-30.82.221-19.802 22.125z"
          fill="#951D09"
        />
        <path
          d="M123.823 266.758l-4.958-.618 15.682-12.375 19.135-21.433 1.288 3.647-19.016 20.479-12.131 10.3z"
          fill="#CC3B1E"
        />
        <path
          d="M126.875 267.138l31.627-9.804 36.516-3.965 21.185-22.339-5.805 46.529-83.523-10.421z"
          fill="#30180E"
        />
        <path
          d="M158.336 257.121l-3.342-21.332 39.214 17.868-35.872 3.464zM194.303 252.893l-14.475-31.437 21.691 1.545-7.216 29.892zM215.774 231.364l-5.129-17.876 10.554-25.602-5.425 43.478z"
          fill="#E34C2D"
        />
        <path
          d="M158.407 258.099l36.588-4.537.957 15.612-37.545-11.075zM201.923 222.86l13.636 8.674-20.47 21.266 6.834-29.94z"
          fill="#951D09"
        />
        <path
          d="M163.439 271.7l14.401-8.899 14.518-14.466 16.443-.662 14.387-6.765 9.837-19.792-7.281 58.358-62.305-7.774z"
          fill="#7D0E03"
        />
        <path
          d="M182.961 266.334l4.958-13.683 4-4.268 16.429-.551 2.935 6.001-17.243.124-11.079 12.377z"
          fill="#951D09"
        />
        <path
          d="M177.309 273.431l-2.774-.346 8.773-6.923 10.706-11.991.72 2.04-10.639 11.458-6.786 5.762z"
          fill="#CC3B1E"
        />
        <path
          d="M179.016 273.643l17.695-5.485 20.429-2.218 11.852-12.498-3.247 26.031-46.729-5.83z"
          fill="#30180E"
        />
        <path
          d="M196.617 268.039l-1.869-11.935 21.939 9.997-20.07 1.938zM216.74 265.673l-8.099-17.587 12.136.864-4.037 16.723zM228.752 253.629l-2.869-10.001 5.904-14.324-3.035 24.325z"
          fill="#E34C2D"
        />
        <path
          d="M196.657 268.586l20.47-2.538.535 8.734-21.005-6.196zM221.003 248.871l7.629 4.853-11.452 11.898 3.823-16.751z"
          fill="#951D09"
        />
        <path
          d="M163.439 271.701l14.401-8.9 14.518-14.465 16.443-.663 14.388-6.764 9.837-19.792-7.282 58.357-62.305-7.773z"
          fill="#7D0E03"
        />
        <path
          d="M182.961 266.335l4.958-13.683 4-4.269 16.429-.55 2.935 6-17.243.124-11.079 12.378z"
          fill="#951D09"
        />
        <path
          d="M177.309 273.431l-2.774-.347 8.773-6.923 10.706-11.991.72 2.04-10.639 11.458-6.786 5.763z"
          fill="#CC3B1E"
        />
        <path
          d="M179.016 273.644l17.695-5.485 20.429-2.218 11.852-12.498-3.247 26.031-46.729-5.83z"
          fill="#30180E"
        />
        <path
          d="M196.617 268.039l-1.869-11.935 21.939 9.997-20.07 1.938zM216.74 265.674l-8.098-17.588 12.135.864-4.037 16.724zM228.752 253.629l-2.869-10.001 5.904-14.324-3.035 24.325z"
          fill="#E34C2D"
        />
        <path
          d="M196.657 268.586l20.469-2.539.536 8.735-21.005-6.196zM221.003 248.872l7.629 4.852-11.452 11.898 3.823-16.75z"
          fill="#951D09"
        />
      </g>
      <path
        d="M74.418 215.107c0 12.799-10.376 23.175-23.176 23.175-12.799 0-23.175-10.376-23.175-23.175 0-12.799 10.376-23.175 23.175-23.175 12.8 0 23.176 10.376 23.176 23.175z"
        fill="#262425"
      />
      <circle cx={51.242} cy={215.107} r={21.543} fill="#FCECDD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.156 237.818c-2.586 3.028-16.713-4.793-31.554-17.469-14.84-12.675-24.775-25.405-22.19-28.433 1.478-1.73 6.722.081 13.714 4.315l-.724.518c-5.621-3.389-9.7-4.853-10.808-3.556-2.11 2.47 7.364 14.024 21.16 25.807s26.69 19.332 28.8 16.862c.856-1.004-.199-3.507-2.679-6.916l.837-.251c3.23 4.418 4.61 7.757 3.444 9.123z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.21 212.469c.312 3.97-15.208 8.429-34.664 9.96-19.457 1.531-35.484-.445-35.796-4.415-.179-2.268 4.81-4.695 12.75-6.646l-.147.878c-6.371 1.579-10.29 3.428-10.157 5.128.255 3.238 15.124 4.71 33.21 3.286 18.087-1.423 32.543-5.202 32.288-8.441-.104-1.315-2.62-2.339-6.784-2.996l.414-.77c5.407.841 8.745 2.226 8.886 4.016z"
        fill="#fff"
      />
      <path
        d="M42.26 223.009l-2.318-7.459.83-.258 2.319 7.459-.83.258zM46.86 218.826l-1.897.59.78 2.511-.83.258-2.318-7.459 2.727-.848c.812-.252 1.474-.241 1.985.034.51.274.892.818 1.145 1.63.526 1.696-.004 2.79-1.592 3.284zm-2.125-.143l1.886-.587c1.028-.319 1.354-1.082.979-2.29-.179-.575-.432-.957-.758-1.147-.33-.197-.764-.212-1.303-.044l-1.886.586 1.082 3.482zM51.303 220.199l-2.318-7.459 4.462-1.387.228.733-3.633 1.129.905 2.91 3.072-.954.228.733-3.072.954.958 3.083-.83.258zM56.803 210.984c-1.078.335-1.49.908-1.238 1.72.14.453.36.728.658.824.303.087.858.1 1.666.038.813-.071 1.42-.02 1.821.155.4.168.695.56.887 1.178.475 1.531-.08 2.543-1.669 3.037-.524.163-1.201.306-2.03.43l-.404.066-.128-.716c1.017-.175 1.781-.341 2.291-.5 1.064-.33 1.44-.995 1.13-1.994-.125-.402-.333-.653-.624-.752-.286-.108-.767-.124-1.445-.047-.896.082-1.564.037-2.004-.134-.441-.178-.766-.601-.973-1.269-.416-1.337.178-2.254 1.78-2.752.525-.163 1.17-.305 1.937-.425l.383-.06.142.724c-1.036.188-1.763.347-2.18.477z"
        fill="#4A4A4A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M258.457 79.08h-7.293a5.47 5.47 0 00-5.47 5.47v7.293a5.47 5.47 0 005.47 5.47h7.293a5.47 5.47 0 005.47-5.47V84.55a5.47 5.47 0 00-5.47-5.47zm-10.939 5.47a3.647 3.647 0 013.646-3.646h7.293a3.647 3.647 0 013.647 3.646v7.293a3.647 3.647 0 01-3.647 3.647h-7.293a3.647 3.647 0 01-3.646-3.647V84.55zm7.293 8.205a4.558 4.558 0 110-9.115 4.558 4.558 0 010 9.115zm-.001-1.822a2.735 2.735 0 100-5.47 2.735 2.735 0 000 5.47zm5.47-7.293a.911.911 0 11-1.823 0 .911.911 0 011.823 0zM229.966 89.835l1.29.151-.58 1.162c-.282.567-.565 1.133-.849 1.7-.033.12-.092.225-.18.362-.036.057-.161.24-.167.248-.032.05-.057.088-.074.12v2.177c0 5.572-5.393 9.112-10.485 9.112-1.042 0-1.834-.05-2.74-.248-1.492-.325-2.602-.972-3.11-2.103l-.523-1.165 1.271-.117c1.15-.105 2.147-.324 2.913-.618-2.103-.338-3.28-1.261-3.28-2.995v-.911h.911c.2 0 .381-.017.542-.046-1.577-.944-2.367-2.457-2.367-4.556l-.001-.185c-.006-1.058.051-1.623.341-2.344.185-.463.453-.89.814-1.283l.688-.747.669.764c2.204 2.52 4.383 4.047 6.608 4.232.009-2.324 1.766-4.083 4.102-4.083 1.089 0 2.077.413 2.854 1.159.424.087.876.159 1.353.214zm-2.015 1.508l-.279-.063-.193-.212c-.467-.512-1.053-.783-1.72-.783-1.333 0-2.279.95-2.279 2.279 0 .217-.006.354-.033.533-.108.716-.509 1.29-1.335 1.29-2.733 0-5.198-1.464-7.603-3.965-.124.377-.153.764-.149 1.49l.001.196c0 1.867.757 2.888 2.547 3.458l.636.202v.666c0 .81-.766 1.57-1.887 1.911.514.39 1.565.6 3.265.6h.911v.912c0 1.306-1.501 2.329-3.768 2.863.74.226 1.724.324 2.856.324 4.207 0 8.662-2.925 8.662-7.29v-2.278c0-.268.077-.5.206-.742a3.41 3.41 0 01.175-.288l.098-.145.073-.145.351-.702c-.182-.034-.36-.072-.535-.111zM234.5 63.786l-1.539 1.924-5.388-2.694s-.206-4.052.385-6.542c.607-2.553 2.694-6.157 2.694-6.157l4.618-1.54.385 1.155s1.642-.384 2.694-.384 2.693.384 2.693.384l.385-1.154 4.617 1.54s2.087 3.603 2.694 6.156c.592 2.49.385 6.542.385 6.542l-5.387 2.694-1.54-1.924s-2.344.384-3.847.384c-1.503 0-3.849-.384-3.849-.384zm-.612-1.604l-1.411 1.41-3.498-1.538s-.175-3.377.327-5.452c.515-2.128 2.285-5.13 2.285-5.13l2.65-.93.353 1.057s1.412-.77 3.528-.77c2.115 0 4.232.77 4.232.77l.353-1.058 1.944.93s1.77 3.003 2.285 5.131c.502 2.075.327 5.452.327 5.452l-3.145 1.539-1.059-1.411s-3.174.834-4.937.834c-1.763 0-4.234-.834-4.234-.834z"
        fill="#FCECDD"
      />
      <ellipse cx={234.616} cy={57.741} rx={1.764} ry={1.94} fill="#FCECDD" />
      <ellipse cx={241.318} cy={57.741} rx={1.764} ry={1.94} fill="#FCECDD" />
      <path
        fill="#fff"
        d="M67.206 95.564L191.91 62.15l34.327 128.112-124.704 33.415z"
      />
      <path
        d="M83.066 132.946l112.439-30.128 15.155 56.561-112.439 30.127-15.155-56.56z"
        fill="#ED5840"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.633 132.697l113.121-30.31 15.338 57.241-113.12 30.311-15.339-57.242zm.864.499l14.973 55.879 111.757-29.945-14.972-55.879-111.758 29.945z"
        fill="#ED5840"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.744 190.096l5.478 20.443c.051.188.244.3.432.25l111.076-29.763a.354.354 0 00.25-.432l-5.478-20.444.681-.182 5.478 20.443a1.058 1.058 0 01-.748 1.296L104.837 211.47a1.058 1.058 0 01-1.296-.748l-5.478-20.444.681-.182z"
        fill="#EBEBEB"
      />
      <path
        d="M153.446 122.761c-.873.251-1.679.591-2.399 1a10.086 10.086 0 00-3.939 3.976c-1.796 3.334-1.736 5.649-.856 8.646.687 2.339 2.796 3.849 5.07 4.113 1.215.116 2.728-.404 3.605-1.223.441-.41.72-.869.811-1.348.084-.477.007-.998-.399-1.626l-4.107-6.345c-.643-.991.302-1.457.761-.83l4.654 6.361c.576.887.764 1.838.609 2.689-.16.856-.641 1.595-1.269 2.176-1.254 1.172-3.103 1.818-4.843 1.644-1.442-.14-2.946-.707-4.137-1.742 1.377 12.502-3.813 14.201-9.229 22.699-4.139 6.485-3.156 15.024 1.283 20.078 1.766 2.011.01 3.625-2.071 1.611-3.775-3.645-5.497-8.491-4.779-13.465.275-1.884-1.463-3.547-3.041-2.973-.749.277-1.264 1.007-1.349 1.906-.937 8.672 3.077 16.374 7.213 19.15 2.07 1.385 4.559 1.568 6.664.552.925-.45 2.169-1.333 3.381-2.478 1.599.439 3.313.452 5.098-.107l11.458-3.59c-.863-2.059-3.016-3.625-4.908-3.13-.548.134-1.081-.408-1.011-1.026l1.01-8.423c.194-1.619-.276-2.951-1.143-4.028-.868-1.08-2.174-1.802-3.512-2.2-1.371-.407-1.12-2.013.222-1.709 1.684.387 3.286 1.375 4.434 2.805a7.344 7.344 0 011.564 5.487l-.914 7.575a5.129 5.129 0 011.805.312c2.54-1.7 3.923-3.435 4.608-5.368l4.203 7.714 9.791-3.067c-.867-2.039-2.98-3.557-4.818-2.981-.347.109-.73-.062-.93-.418-1.761-3.082-3.178-5.804-4.396-9.657-.248-.787.627-1.151.917-.524 1.499 3.213 2.63 6.118 4.641 9.024 2.725-.807 5.064 1.418 6.08 4.087l4.986-1.562c-.941-2.979-3.746-4.772-6.391-4.183-9.004-13.658-5.662-14.165-12.286-29.282-.722-1.642-.415-3.391 1.244-4.916l4.494-4.143c3.012-2.549 2.597-4.748 2.172-6.672-.498-2.248-1.962-3.011-3.601-2.497-4.511 1.413-4.907.697-7.476-.827-3.184-1.887-6.363-2.008-8.974-1.265z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.63 219.387l.667-.934 1.204-.249c.168-.034.243-.237.168-.453l-.813-2.343c-.075-.216-.272-.362-.44-.328l-2.433.503c-.168.035-.244.238-.169.454l.814 2.343c.075.216.271.362.439.327l.305-.062.258.742zm.464-1.285l-.389.543-.151-.432-.614.127-.822-2.363 2.458-.507.822 2.362-1.304.27zM123.407 210.949l.522.388-1.351.278c-.435.09-.63.614-.436 1.171l.21.604.315-.065-.21-.604c-.117-.334 0-.649.261-.702l1.351-.279-.2.536.321.239.411-1.101-1.071-.796-.123.331zm.361 3.663l-.522-.387 1.351-.279c.434-.09.63-.614.436-1.17l-.21-.605-.315.065.21.605c.117.334-.001.648-.261.702l-1.351.278.2-.536-.322-.239-.41 1.101 1.071.796.123-.331zM140.408 206.464c-.221.046-.353.109-.481.246a.802.802 0 00-.122.173 1.242 1.242 0 00-.21-.098 1 1 0 00-.581-.033c-.573.118-.777.812-.503 1.603.208.596.668 1.119 1.345 1.577.356.24.78.462 1.066.568l.163.061.103-.115c.178-.202.401-.559.553-.904.29-.657.349-1.287.142-1.883-.272-.782-.906-1.309-1.475-1.195zm1.175 1.257c.163.469.113.996-.142 1.576a3.612 3.612 0 01-.505.828 5.3 5.3 0 01-.975-.523c-.597-.403-.983-.841-1.146-1.31-.204-.585-.061-1.068.334-1.149a.728.728 0 01.433.02.906.906 0 01.252.141l.166.131.058-.179a.589.589 0 01.128-.223c.092-.098.183-.142.361-.179.392-.078.835.29 1.036.867z"
        fill="#73767B"
      />
      <path
        d="M114.005 214.086l.046.173-.4 2.518-.325.087.42-2.437-1.311.351-.067-.253 1.637-.439zM116.423 215.161l.068.253-1.75.469-.049-.182.635-1.969.252-.067-.14.558-.416 1.313 1.4-.375zm-.768-1.517l.649 2.422-.308.083-.649-2.422.308-.083zM84.102 126.937l.021-.006.056.209-.021.006a.776.776 0 00-.31.152.552.552 0 00-.164.225.719.719 0 00-.049.267c.002.093.014.186.039.276l.076.285a.81.81 0 00.092.221.52.52 0 00.129.143c.047.036.096.06.147.071.051.011.101.01.15-.003a.372.372 0 00.143-.073.333.333 0 00.088-.122.435.435 0 00.032-.16.645.645 0 00-.024-.184.656.656 0 00-.066-.161.45.45 0 00-.103-.126.322.322 0 00-.303-.066.39.39 0 00-.178.102.45.45 0 00-.11.169.365.365 0 00-.018.192l-.13.033a.853.853 0 010-.273.563.563 0 01.082-.207.495.495 0 01.145-.144.641.641 0 01.194-.086.52.52 0 01.477.087.638.638 0 01.155.178.87.87 0 01.126.492.63.63 0 01-.06.241.532.532 0 01-.15.191.636.636 0 01-.245.12.58.58 0 01-.292.01.615.615 0 01-.24-.121.818.818 0 01-.18-.209.974.974 0 01-.11-.257l-.032-.116a2.01 2.01 0 01-.066-.413c-.008-.138.008-.27.047-.394a.761.761 0 01.215-.331c.104-.095.25-.168.437-.218zM85.191 128.585a.155.155 0 01.01-.115c.02-.037.053-.061.103-.075.05-.013.091-.009.125.014a.154.154 0 01.068.094.153.153 0 01-.012.115c-.018.035-.052.059-.102.073-.05.013-.091.009-.126-.012a.156.156 0 01-.066-.094zm-.314-1.175a.158.158 0 01.01-.116c.02-.036.054-.061.103-.074.05-.014.092-.009.125.013a.156.156 0 01.069.095.15.15 0 01-.013.114c-.018.036-.052.06-.101.073-.05.013-.092.009-.126-.012a.151.151 0 01-.067-.093zM87.086 128.001l.054.202-1.269.34-.047-.177.445-.877c.055-.108.096-.198.122-.27a.701.701 0 00.047-.187.451.451 0 00-.013-.157.38.38 0 00-.087-.162.308.308 0 00-.148-.094.354.354 0 00-.196.002.43.43 0 00-.202.109.32.32 0 00-.09.172.49.49 0 00.012.217l-.246.066a.654.654 0 01-.009-.319.549.549 0 01.155-.273.715.715 0 01.326-.174.72.72 0 01.332-.019.48.48 0 01.248.127.566.566 0 01.16.434.907.907 0 01-.032.194c-.017.066-.04.134-.07.201a2.77 2.77 0 01-.096.203l-.368.702.972-.26zM87.828 125.939l.022-.006.056.209-.022.006a.764.764 0 00-.31.151.552.552 0 00-.164.225.719.719 0 00-.048.267c.001.094.014.186.038.276l.077.285a.81.81 0 00.092.221c.038.06.08.108.128.144a.376.376 0 00.147.07.357.357 0 00.294-.075.34.34 0 00.087-.122.441.441 0 00.033-.16.672.672 0 00-.09-.346.464.464 0 00-.104-.126.32.32 0 00-.302-.066.409.409 0 00-.179.102.451.451 0 00-.11.17.362.362 0 00-.017.191l-.13.034a.853.853 0 010-.273.563.563 0 01.082-.207.5.5 0 01.145-.145.668.668 0 01.194-.086.509.509 0 01.477.088.624.624 0 01.155.178.856.856 0 01.126.491.624.624 0 01-.06.241.544.544 0 01-.15.192.665.665 0 01-.246.12.58.58 0 01-.532-.112.81.81 0 01-.18-.208.985.985 0 01-.11-.257l-.03-.116a2.02 2.02 0 01-.067-.413 1.11 1.11 0 01.047-.395.751.751 0 01.215-.33 1.02 1.02 0 01.436-.218zM90.188 126.572l-.518.138-.056-.209.518-.138a.56.56 0 00.23-.113.31.31 0 00.1-.17.432.432 0 00-.008-.206.43.43 0 00-.094-.176.337.337 0 00-.173-.105.502.502 0 00-.259.011l-.457.123.462 1.727-.256.069-.52-1.938.715-.191a.863.863 0 01.392-.024c.114.024.21.073.286.149.076.074.13.169.16.284a.63.63 0 01.007.339.516.516 0 01-.176.262.941.941 0 01-.353.168zM90.958 125.103l.249-.067 1.058 1.41.21-1.75.25-.067-.268 2.149-.194.052-1.305-1.727zm-.081.022l.22-.059.352 1.172.203.756-.256.068-.52-1.937zm1.709-.458l.22-.059.519 1.938-.256.068-.202-.756-.281-1.191zM94.68 125.191l.054.203-.65.174-.054-.203.65-.174zM96.853 123.523l.52 1.938-.259.069-1.376-1.233.4 1.495-.257.069-.519-1.938.257-.069L97 125.09l-.401-1.499.254-.068zM97.536 124.663l-.008-.031a.924.924 0 01-.032-.301.71.71 0 01.068-.268.598.598 0 01.165-.209.664.664 0 01.256-.129.662.662 0 01.288-.017.596.596 0 01.25.098c.075.051.14.116.193.198a.928.928 0 01.123.277l.008.03a.924.924 0 01.032.301.712.712 0 01-.069.268.627.627 0 01-.422.337.663.663 0 01-.287.019.649.649 0 01-.442-.297.92.92 0 01-.123-.276zm.238-.097l.008.031c.02.071.046.137.08.196a.553.553 0 00.121.148.41.41 0 00.16.081.39.39 0 00.191-.007.368.368 0 00.263-.239.55.55 0 00.03-.188.786.786 0 00-.027-.21l-.008-.031a.765.765 0 00-.081-.194.532.532 0 00-.123-.148.372.372 0 00-.349-.078.368.368 0 00-.263.242.551.551 0 00-.03.189.8.8 0 00.028.208zM99.702 124.599l.067-1.324.252-.067-.132 1.579-.165.044-.022-.232zm-.655-1.13l.734 1.116.085.208-.165.044-.907-1.3.253-.068zM101.36 123.224l.176-.047a.484.484 0 00.202-.1.297.297 0 00.094-.152.444.444 0 00-.09-.359.264.264 0 00-.143-.085.434.434 0 00-.199.012.415.415 0 00-.173.091.314.314 0 00-.09.335l-.246.066a.525.525 0 01.003-.289.553.553 0 01.157-.249.69.69 0 01.295-.156.742.742 0 01.324-.02.47.47 0 01.254.129.59.59 0 01.154.282.485.485 0 01-.056.349.553.553 0 01-.152.168.758.758 0 01-.259.118l-.211.056-.04-.149zm.055.203l-.04-.148.21-.057a.963.963 0 01.318-.038.45.45 0 01.364.201.622.622 0 01.093.419.503.503 0 01-.081.213.58.58 0 01-.165.162.809.809 0 01-.481.131.662.662 0 01-.224-.052.505.505 0 01-.288-.351l.246-.066a.368.368 0 00.092.166c.044.042.097.07.159.084a.453.453 0 00.208-.012.46.46 0 00.184-.09.294.294 0 00.095-.154.413.413 0 00-.009-.213.37.37 0 00-.104-.185.305.305 0 00-.174-.077.594.594 0 00-.228.019l-.175.048zM103.742 122.55l.079.296c.043.159.064.297.065.413a.715.715 0 01-.052.297.474.474 0 01-.154.196.688.688 0 01-.241.112.74.74 0 01-.214.027.498.498 0 01-.365-.171.883.883 0 01-.146-.221 1.808 1.808 0 01-.117-.325l-.08-.295a1.654 1.654 0 01-.064-.411.72.72 0 01.055-.292.47.47 0 01.153-.192.737.737 0 01.242-.11.719.719 0 01.215-.028.489.489 0 01.362.164.844.844 0 01.145.217c.044.089.083.197.117.323zm-.158.402l-.101-.376a1.504 1.504 0 00-.077-.225.732.732 0 00-.09-.159.34.34 0 00-.105-.094.267.267 0 00-.119-.037.38.38 0 00-.135.014.342.342 0 00-.147.075.277.277 0 00-.087.133.57.57 0 00-.02.203c.005.081.022.176.051.285l.101.377c.023.087.049.162.076.226.029.064.06.117.093.16a.406.406 0 00.106.099.298.298 0 00.12.042.397.397 0 00.284-.09.298.298 0 00.084-.138.589.589 0 00.019-.209 1.572 1.572 0 00-.053-.286zM104.531 123.229l.054.198a.647.647 0 01.007.272.652.652 0 01-.111.273l-.166-.06a.834.834 0 00.04-.139.572.572 0 00.01-.137.577.577 0 00-.02-.14l-.054-.202.24-.065zM106.789 122.721l.054.202-1.268.34-.048-.177.446-.877c.055-.107.095-.197.122-.269a.716.716 0 00.046-.188.428.428 0 00-.099-.319.317.317 0 00-.148-.094.354.354 0 00-.196.003.434.434 0 00-.202.108.32.32 0 00-.091.173.487.487 0 00.012.216l-.246.066a.652.652 0 01-.008-.319.54.54 0 01.155-.272.705.705 0 01.325-.175.736.736 0 01.332-.019c.098.02.181.062.248.128a.523.523 0 01.143.253.533.533 0 01.017.18 1.276 1.276 0 01-.102.396c-.028.067-.06.135-.095.202l-.369.702.972-.26zM108.022 121.404l.079.295c.043.159.065.297.066.413a.749.749 0 01-.052.297.484.484 0 01-.154.196.693.693 0 01-.242.112.733.733 0 01-.213.027.503.503 0 01-.195-.043.559.559 0 01-.171-.128.911.911 0 01-.146-.221 1.808 1.808 0 01-.117-.325l-.079-.295a1.66 1.66 0 01-.065-.411.716.716 0 01.055-.291.468.468 0 01.154-.193.752.752 0 01.241-.11.757.757 0 01.215-.028.485.485 0 01.362.164.863.863 0 01.146.217c.043.089.082.197.116.324zm-.157.401l-.101-.376a1.498 1.498 0 00-.078-.225.732.732 0 00-.089-.159.353.353 0 00-.105-.094.271.271 0 00-.12-.037.38.38 0 00-.135.014.354.354 0 00-.147.075.298.298 0 00-.087.133.572.572 0 00-.019.203c.004.081.021.176.05.285l.101.377c.024.087.049.162.077.226a.803.803 0 00.092.161.422.422 0 00.107.098.288.288 0 00.119.042.397.397 0 00.284-.09.295.295 0 00.085-.138.615.615 0 00.018-.209 1.576 1.576 0 00-.052-.286zM109.856 121.899l.054.203-1.269.34-.047-.177.445-.877c.055-.108.096-.198.122-.27a.713.713 0 00.047-.188.455.455 0 00-.013-.156.384.384 0 00-.087-.162.311.311 0 00-.148-.095.364.364 0 00-.196.003.439.439 0 00-.202.108.327.327 0 00-.091.173.488.488 0 00.013.216l-.247.066a.648.648 0 01-.008-.318.545.545 0 01.155-.273.716.716 0 01.326-.174.718.718 0 01.331-.019.48.48 0 01.249.127.566.566 0 01.16.434.923.923 0 01-.032.194 1.553 1.553 0 01-.07.201 3.1 3.1 0 01-.096.203l-.368.702.972-.261zM110.46 119.866l.523 1.948-.247.066-.439-1.641-.448.314-.06-.222.633-.455.038-.01zM128.818 211.84l.067.253-1.75.469-.048-.181.635-1.969.251-.068-.14.558-.416 1.314 1.401-.376zm-.769-1.516l.649 2.422-.307.083-.649-2.423.307-.082zM129.4 211.098l.219-.059a.595.595 0 00.252-.125.38.38 0 00.119-.19.55.55 0 00-.114-.449.324.324 0 00-.178-.106.517.517 0 00-.249.015.519.519 0 00-.216.113.392.392 0 00-.112.419l-.308.082a.651.651 0 01.003-.361.697.697 0 01.197-.311.861.861 0 01.368-.195.936.936 0 01.406-.025.599.599 0 01.317.161.747.747 0 01.193.353.608.608 0 01-.07.437.71.71 0 01-.19.209.963.963 0 01-.324.148l-.263.07-.05-.186zm.067.253l-.049-.185.263-.07c.154-.042.286-.058.397-.048a.611.611 0 01.277.083.53.53 0 01.177.168.757.757 0 01.117.523.633.633 0 01-.101.266.712.712 0 01-.206.203 1.008 1.008 0 01-.602.163.78.78 0 01-.279-.064.618.618 0 01-.223-.166.692.692 0 01-.137-.272l.308-.083a.4.4 0 00.313.312.57.57 0 00.26-.014.584.584 0 00.23-.114.358.358 0 00.118-.192.52.52 0 00-.011-.266.462.462 0 00-.129-.231.393.393 0 00-.219-.097.733.733 0 00-.284.025l-.22.059zM132.149 209.225l.046.173-.4 2.518-.325.087.42-2.437-1.311.351-.067-.253 1.637-.439z"
        fill="#73767B"
      />
      <path
        d="M103.426 191.216l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M104.913 190.817l.685 2.556-1.704.456-.684-2.555 1.703-.457zm0 0l.685 2.556-1.704.456-.684-2.555 1.703-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M106.401 190.419l.684 2.555-1.703.457-.685-2.556 1.704-.456zm0 0l.684 2.555-1.703.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M107.888 190.02l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M109.375 189.622l.685 2.555-1.704.457-.684-2.556 1.703-.456zm0 0l.685 2.555-1.704.457-.684-2.556 1.703-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M110.863 189.223l.684 2.556-1.703.456-.685-2.555 1.704-.457zm0 0l.684 2.556-1.703.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M112.35 188.825l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M113.412 188.54l.684 2.556-1.277.342-.685-2.555 1.278-.343zM115.325 188.028l.684 2.555-1.703.457-.685-2.556 1.704-.456zm0 0l.684 2.555-1.703.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M116.812 187.629l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M117.874 187.345l.684 2.555-1.277.342-.685-2.555 1.278-.342zM119.787 186.832l.685 2.555-1.704.457-.685-2.555 1.704-.457zm0 0l.685 2.555-1.704.457-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M121.274 186.433l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M122.761 186.035l.685 2.555-1.703.457-.685-2.556 1.703-.456zm0 0l.685 2.555-1.703.457-.685-2.556 1.703-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M124.249 185.636l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M125.31 185.352l.685 2.555-1.278.343-.684-2.556 1.277-.342zM127.223 184.839l.685 2.556-1.703.456-.685-2.555 1.703-.457zm0 0l.685 2.556-1.703.456-.685-2.555 1.703-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M128.711 184.441l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M129.772 184.156l.685 2.556-1.278.342-.684-2.555 1.277-.343zM131.685 183.644l.685 2.555-1.703.457-.685-2.556 1.703-.456zm0 0l.685 2.555-1.703.457-.685-2.556 1.703-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M133.173 183.245l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M134.66 182.847l.685 2.555-1.704.457-.684-2.556 1.703-.456zm0 0l.685 2.555-1.704.457-.684-2.556 1.703-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M136.148 182.448l.684 2.556-1.703.456-.685-2.555 1.704-.457zm0 0l.684 2.556-1.703.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M137.635 182.05l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M139.122 181.651l.685 2.556-1.704.456-.684-2.555 1.703-.457zm0 0l.685 2.556-1.704.456-.684-2.555 1.703-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M140.61 181.253l.684 2.555-1.703.457-.685-2.556 1.704-.456zm0 0l.684 2.555-1.703.457-.685-2.556 1.704-.456zM87.27 95.484l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M88.757 95.085l.685 2.556-1.703.456-.685-2.555 1.703-.457zm0 0l.685 2.556-1.703.456-.685-2.555 1.703-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M90.245 94.687l.684 2.555-1.703.457-.685-2.556 1.704-.456zm0 0l.684 2.555-1.703.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M91.732 94.288l.685 2.556-1.704.456-.685-2.555 1.704-.457zm0 0l.685 2.556-1.704.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M93.22 93.89l.684 2.555-1.703.457-.685-2.556 1.703-.456zm0 0l.684 2.555-1.703.457-.685-2.556 1.703-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M94.707 93.491l.684 2.556-1.703.456-.685-2.555 1.704-.457zm0 0l.684 2.556-1.703.456-.685-2.555 1.704-.457z"
        fill="#1D1F1E"
      />
      <path
        d="M96.194 93.093l.685 2.555-1.704.457-.685-2.556 1.704-.456zm0 0l.685 2.555-1.704.457-.685-2.556 1.704-.456z"
        fill="#1D1F1E"
      />
      <path
        d="M87.796 98.81l.548 2.045-1.363.365-.547-2.044 1.362-.365zm0 0l.548 2.045-1.363.365-.547-2.044 1.362-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M88.986 98.492l.548 2.044-1.363.365-.547-2.044 1.362-.365zm0 0l.548 2.044-1.363.365-.547-2.044 1.362-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M90.176 98.173l.548 2.044-1.363.365-.548-2.044 1.363-.365zm0 0l.548 2.044-1.363.365-.548-2.044 1.363-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M91.366 97.854l.548 2.044-1.363.366-.548-2.045 1.363-.365zm0 0l.548 2.044-1.363.366-.548-2.045 1.363-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M92.556 97.535l.548 2.045-1.363.365-.548-2.044 1.363-.366zm0 0l.548 2.045-1.363.365-.548-2.044 1.363-.366z"
        fill="#C4C4C4"
      />
      <path
        d="M93.746 97.216l.548 2.045-1.363.365-.548-2.044 1.363-.365zm0 0l.548 2.045-1.363.365-.548-2.044 1.363-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M94.936 96.898l.547 2.044-1.362.365-.548-2.044 1.363-.365zm0 0l.547 2.044-1.362.365-.548-2.044 1.363-.365z"
        fill="#C4C4C4"
      />
      <path
        d="M144.67 205.871l.047.173-.401 2.518-.324.087.42-2.438-1.311.351-.068-.253 1.637-.438zM145.754 206.716l.22-.059a.595.595 0 00.252-.125.372.372 0 00.118-.19.428.428 0 00-.004-.227.55.55 0 00-.109-.222.324.324 0 00-.178-.106.543.543 0 00-.249.015.507.507 0 00-.216.113.39.39 0 00-.116.185.434.434 0 00.004.234l-.308.083a.651.651 0 01.003-.361.692.692 0 01.196-.312.865.865 0 01.369-.195.931.931 0 01.405-.025c.124.022.23.076.318.161a.754.754 0 01.193.354.593.593 0 01-.071.436.696.696 0 01-.19.209.954.954 0 01-.324.148l-.263.07-.05-.186zm.068.253l-.049-.185.262-.07c.155-.042.287-.058.398-.048.111.01.203.037.277.083a.53.53 0 01.177.168.775.775 0 01.117.523.621.621 0 01-.102.266.712.712 0 01-.205.204 1.019 1.019 0 01-.292.128c-.106.028-.209.04-.31.035a.814.814 0 01-.28-.065.636.636 0 01-.36-.438l.308-.083a.453.453 0 00.114.207.403.403 0 00.2.105.57.57 0 00.26-.014.571.571 0 00.23-.114.358.358 0 00.118-.192.52.52 0 00-.011-.266.455.455 0 00-.13-.231.387.387 0 00-.218-.097.733.733 0 00-.284.025l-.22.059zM149.106 207.007l.068.253-1.586.425-.059-.221.557-1.097c.069-.134.119-.247.152-.336a.893.893 0 00.059-.235.586.586 0 00-.017-.196.47.47 0 00-.108-.202.38.38 0 00-.185-.118.444.444 0 00-.245.003.551.551 0 00-.253.135.405.405 0 00-.113.216.617.617 0 00.015.271l-.307.082a.815.815 0 01-.011-.398.683.683 0 01.194-.341.892.892 0 01.407-.218.906.906 0 01.415-.024.59.59 0 01.31.16.701.701 0 01.2.541 1.12 1.12 0 01-.04.243 1.76 1.76 0 01-.088.252 3.2 3.2 0 01-.119.253l-.46.877 1.214-.325z"
        fill="#73767B"
      />
      <circle
        cx={79.188}
        cy={100.754}
        r={4.586}
        transform="rotate(-15 79.188 100.754)"
        fill="#ED5840"
      />
    </svg>
  );
}

export default Pick3;
